// src/queries/entityApiConfig.js

import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

/**
 * ENTITY API CONFIGURATION (Master Data)
 * Integrated with pms-api REST endpoints: /api/v1/master-data
 */

export const entityConfig = {
  /* --------------------------------- GET ---------------------------------- */
  getAllEntityCount: {
    key: "getAllEntityCount",
    url: "/api/v1/master-data/counts",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  // getSpecificEntityData: entity goes in URL path, rest become query params.
  // useFetchQuery does NOT append query params when url is a function, so we
  // build the full URL (including query string) inside the function itself.
  getSpecificEntityData: {
    key: "getSpecificEntityData",
    url: (params) => {
      const { entity, ...rest } = params;
      const qs = new URLSearchParams(
        Object.entries(rest).filter(
          ([, v]) => v !== undefined && v !== null && v !== "",
        ),
      ).toString();
      return `/api/v1/master-data/${entity}${qs ? `?${qs}` : ""}`;
    },
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  // slug is passed as a query param by useFetchQuery (static URL, not a function)
  getAllMasterFieldsData: {
    key: "getAllMasterFieldsData",
    url: "/api/v1/master-data/fields",
    method: "GET",
    options: {
      ...QUERY_PRESETS.STATIC,
    },
  },

  // Used in hotel-creation forms; counts endpoint is the closest equivalent
  getAllEntityForHotelCreation: {
    key: "getAllEntityForHotelCreation",
    url: "/api/v1/master-data/counts",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getBookingSourceTree: {
    key: "getBookingSourceTree",
    url: "/api/v1/master-data/bookingsource/tree",
    method: "GET",
    options: {
      ...QUERY_PRESETS.STATIC,
    },
  },

  /* -------------------------------- POST ---------------------------------- */
  createEntity: {
    key: "createEntity",
    url: (data) => `/api/v1/master-data/${data.entity}`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllEntityCount",
        "getAllMasterFieldsData",
        "getAllEntityForHotelCreation",
        "getSpecificEntityData",
      ],
    },
  },

  /* --------------------------------- PATCH -------------------------------- */
  updateEntity: {
    key: "updateEntity",
    url: (data) => `/api/v1/master-data/${data.entity}/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllEntityCount",
        "getAllMasterFieldsData",
        "getAllEntityForHotelCreation",
        "getSpecificEntityData",
      ],
    },
  },

  restoreEntity: {
    key: "restoreEntity",
    url: (data) => `/api/v1/master-data/${data.entity}/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllEntityCount",
        "getAllMasterFieldsData",
        "getAllEntityForHotelCreation",
        "getSpecificEntityData",
      ],
    },
  },

  /* ------------------------------- DELETE -------------------------------- */
  deleteEntity: {
    key: "deleteEntity",
    url: (data) => `/api/v1/master-data/${data.entity}/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllEntityCount",
        "getAllMasterFieldsData",
        "getAllEntityForHotelCreation",
        "getSpecificEntityData",
      ],
    },
  },
};
